import { ActionIcon, ButtonMantine, Card, CopyButton, Group, Stack, Text, Tooltip } from 'ui';
import { IconCheck, IconCopy, IconFiles, IconLink } from 'ui/Icons';

import { QRCodeButton } from '../../Modals';

export const CopyLink = ({ link, grow }: { link: string; grow?: boolean }) => {
  return (
    <Card
      radius="sm"
      p="xs"
      bg="gray.0"
      h={40}
      shadow="none"
      style={{ border: '1px solid #eeeeee', flexGrow: grow ? 1 : 0 }}
    >
      <Group c="gray" fz="sm" wrap="nowrap" gap={'xs'}>
        <CopyButton value={link}>
          {({ copied, copy }) => (
            <Tooltip label={copied ? 'Copied' : 'Copy Link'} withinPortal={true}>
              <ActionIcon
                onClick={copy}
                variant="subtle"
                color="gray"
                size=""
                style={{ flexShrink: 0 }}
              >
                {copied ? <IconCheck size={16} /> : <IconLink size={16} />}
              </ActionIcon>
            </Tooltip>
          )}
        </CopyButton>
        <Text
          c="gray"
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          fz="sm"
        >
          {link}
        </Text>
      </Group>
    </Card>
  );
};

export const CopyLinkButton = ({
  link,
  actionIconOnly,
}: {
  link: string;
  actionIconOnly?: boolean;
}) => {
  if (!link) return null;
  return (
    <CopyButton value={link}>
      {({ copied, copy }) =>
        actionIconOnly ? (
          <ActionIcon size="md" onClick={copy} style={{ flexShrink: 0 }}>
            {copied ? <IconCheck size="1rem" /> : <IconFiles brand="tabler" />}
          </ActionIcon>
        ) : (
          <ButtonMantine
            color={copied ? 'cobalt.4' : 'cobalt'}
            onClick={copy}
            rightSection={copied ? <IconCheck size="1rem" /> : <IconCopy size="1rem" />}
            size={'md'}
            style={{ flexShrink: 0 }}
          >
            {copied ? 'Copied' : 'Copy Link'}
          </ButtonMantine>
        )
      }
    </CopyButton>
  );
};

export const CopyLinkGroup = ({
  link,
  actionIconOnly,
  direction = 'row',
  withQrCode,
}: {
  link: string;
  actionIconOnly?: boolean;
  direction?: 'row' | 'column';
  withQrCode?: boolean;
}) => {
  const horizontal = direction === 'row';
  return horizontal ? (
    <Group wrap="nowrap">
      <CopyLink link={link} grow />
      <Group gap="xs" wrap="nowrap">
        {withQrCode && <QRCodeButton size="md" link={link} />}
        <CopyLinkButton link={link} actionIconOnly={actionIconOnly} />
      </Group>
    </Group>
  ) : (
    <Stack h={187} justify="space-between">
      <CopyLink link={link} />
      <CopyLinkButton link={link} actionIconOnly={actionIconOnly} />
    </Stack>
  );
};
